import urlcat from 'urlcat';

// eslint-disable-next-line modernloop/restrict-imports.cjs
import { AddQueueModalOpenUrlParam } from 'src/views-new/Settings/Tasks/Queue/Modal/AddQueue';
// eslint-disable-next-line modernloop/restrict-imports.cjs
import { TaskSettingsTabs } from 'src/views-new/Settings/types';

import { OrganizationSettingsTab, getOrganizationSettingUrls } from './getOrganizationSettingUrls';

const TASK_SETTINGS_TAB_ROUTE_MAP: Record<TaskSettingsTabs, OrganizationSettingsTab> = {
  [TaskSettingsTabs.GENERAL]: OrganizationSettingsTab.TASK_SETTINGS,
  [TaskSettingsTabs.TASK_TAGS]: OrganizationSettingsTab.TASK_TAGS,
  [TaskSettingsTabs.TASK_QUEUE]: OrganizationSettingsTab.TASK_QUEUES,
  [TaskSettingsTabs.TASK_RESCHEDULE_REASONS]: OrganizationSettingsTab.TASK_RESCHEDULE_REASONS,
  [TaskSettingsTabs.SEND_ON_BEHALF_OF_PERMISSIONS]: OrganizationSettingsTab.TASK_SEND_ON_BEHALF_OF_PERMISSIONS,
};

/**
 * Builds the settings URL for a promoted task settings page.
 */
const getTaskSettingsTabUrl = (tab: TaskSettingsTabs, isAddQueueModalOpen: boolean) => {
  const baseUrl = getOrganizationSettingUrls({ tab: TASK_SETTINGS_TAB_ROUTE_MAP[tab] });

  if (!isAddQueueModalOpen) {
    return baseUrl;
  }

  return urlcat(baseUrl, {
    [AddQueueModalOpenUrlParam]: true,
  });
};
export default getTaskSettingsTabUrl;
